module.exports = __webpack_public_path__ + "img/levelchangeup.f24d67cf.svg";